<template>
	<button class="add-content-button" :style="{ backgroundColor: color }" @click="onClick">
		<svg xmlns="http://www.w3.org/2000/svg" width="30.295" height="30.908" viewBox="0 0 30.295 30.908">
			<path
				d="M5,0H25.295a4.9,4.9,0,0,1,5,4.788V26.12a4.9,4.9,0,0,1-5,4.788H5A4.9,4.9,0,0,1,0,26.12V4.788A4.9,4.9,0,0,1,5,0Z"
				fill="#fff"
			/>
			<g transform="translate(178.247 -1176.57)">
				<line
					x2="21.486"
					transform="translate(-174.247 1192.415)"
					fill="none"
					:stroke="color"
					stroke-linecap="round"
					stroke-miterlimit="10"
					stroke-width="3"
				/>
				<line
					y2="21.486"
					transform="translate(-163.504 1181.671)"
					fill="none"
					:stroke="color"
					stroke-linecap="round"
					stroke-miterlimit="10"
					stroke-width="3"
				/>
			</g>
		</svg>

		<slot></slot>
	</button>
</template>

<script>
export default {
	props: {
		color: {
			type: String,
			default: '#1DA1F2'
		}
	},
	methods: {
		onClick(ev) {
			ev.preventDefault();
			ev.stopPropagation();
			this.$emit('click');
		}
	}
};
</script>

<style scoped lang="scss">
.add-content-button {
	background-repeat: no-repeat;
	background-position: 2px 2px;
	border: transparent 1px solid;
	text-transform: uppercase;
	color: #fff;
	font-size: 14px;
	text-align: center;
	min-width: 175px;
	height: 38px;
	padding: 2px;
	padding-left: 30px;
	border-radius: 5px;
	position: relative;
	font-weight: bold;
	outline: none;

	svg {
		width: 30px;
		height: 30px;
		position: absolute;
		left: 2px;
		top: 2px;
	}
}
</style>
